import { render } from "./MonReferent.vue?vue&type=template&id=9ed648ee"
import script from "./MonReferent.vue?vue&type=script&lang=js"
export * from "./MonReferent.vue?vue&type=script&lang=js"

import exportComponent from "/opt/referents/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__